import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = '100%' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="your_vehicle_of_interest">
        <path
          id="Vector"
          d="M4.13289 12.6428H2.2282C1.94789 12.6428 1.68195 12.5278 1.4807 12.3337C1.38229 12.2358 1.3043 12.1193 1.25125 11.991C1.1982 11.8626 1.17114 11.7251 1.17164 11.5862V10.659H4.13289V12.6428ZM18.8673 10.659H21.8285V11.579C21.8285 11.8594 21.7135 12.1253 21.5195 12.3265C21.4215 12.4249 21.305 12.5029 21.1767 12.556C21.0484 12.609 20.9108 12.6361 20.7719 12.6356H18.8673V10.6519V10.659ZM21.3613 14.339V20.434C21.3613 20.9084 21.1744 21.3684 20.8366 21.7062C20.4988 22.044 20.0388 22.2309 19.5645 22.2309H19.356C18.8816 22.2309 18.4216 22.044 18.0838 21.7062C17.746 21.3684 17.5591 20.9084 17.5591 20.434V19.4709H5.49132V20.434C5.49132 20.9084 5.30445 21.3684 4.96664 21.7062C4.62882 22.044 4.16883 22.2309 3.69445 22.2309H3.48601C3.01164 22.2309 2.55164 22.044 2.21383 21.7062C1.87601 21.3684 1.68914 20.9084 1.68914 20.434V14.339H21.3685H21.3613Z"
          fill="#1F3E74"
        />
        <path
          id="Vector_2"
          d="M7.48947 16.6966L5.95853 15.6975L3.1626 15.1656V15.5969C3.16278 15.7426 3.19211 15.8868 3.24885 16.021C3.30635 16.1575 3.38541 16.2725 3.48604 16.3803C3.58666 16.481 3.70885 16.5672 3.84541 16.6175C3.97708 16.6743 4.11891 16.7036 4.26228 16.7038H7.48947V16.6966ZM15.4101 16.6966L16.941 15.6975L19.737 15.1656V15.6328C19.737 15.7694 19.7082 15.9131 19.6579 16.0425C19.6076 16.1719 19.5285 16.2869 19.4279 16.3875C19.3273 16.4881 19.2123 16.5672 19.0829 16.6175C18.9548 16.6686 18.8183 16.6954 18.6804 16.6966H15.4173H15.4101Z"
          fill="white"
        />
        <path
          id="Vector_3"
          d="M17.1852 8.28723H14.763L12.3336 10.6016C12.1108 10.8172 11.8161 10.9322 11.5071 10.9322C11.198 10.9322 10.9105 10.8172 10.6805 10.6088L8.24395 8.28723H5.33301L6.28176 12.65H18.8671L17.1852 8.28723Z"
          fill="#1F3E74"
        />
        <path
          id="Vector_4"
          d="M11.5 9.88998C11.5431 9.88998 11.579 9.87561 11.6078 9.84686L15.5537 6.08779C15.7765 5.87217 16.905 4.72936 16.905 3.44998C16.905 1.74654 15.9059 0.769043 14.1593 0.769043C13.1603 0.769043 12.1972 1.57404 11.7084 2.05561L11.5 2.26404L11.2915 2.05561C10.8028 1.57404 9.83966 0.769043 8.8406 0.769043C7.09403 0.769043 6.09497 1.74654 6.09497 3.44998C6.09497 4.84436 7.43185 6.06623 7.44622 6.08061H7.4606L11.3922 9.84686C11.4213 9.87438 11.4599 9.8898 11.5 9.88998Z"
          fill="#5586D4"
        />
      </g>
    </svg>
  );
};

export default Icon;
